<template>
	<i :class="['tq-icons', iconClass]"></i>
</template>

<script lang="ts">
export default {
	name: "TqIcon",
	props: {
		name: {
			type: String,
			default: "",
		},
	},
	computed: {
		iconClass(){
			return "tq-icon-" + this.name
		}
	}
}
</script>
